import jokerJ01 from '../assets/images/jokers/J01.webp'
import jokerJ02 from '../assets/images/jokers/J02.webp'
import jokerJ03 from '../assets/images/jokers/J03.webp'
import jokerJ04 from '../assets/images/jokers/J04.webp'
import jokerJ05 from '../assets/images/jokers/J05.webp'
import jokerJ06 from '../assets/images/jokers/J06.webp'
import jokerJ07 from '../assets/images/jokers/J07.webp'
import jokerJ08 from '../assets/images/jokers/J08.webp'
import jokerJ09 from '../assets/images/jokers/J09.webp'
import jokerJ10 from '../assets/images/jokers/J10.webp'
import jokerJ11 from '../assets/images/jokers/J11.webp'
import jokerJ12 from '../assets/images/jokers/J12.webp'
import jokerJ13 from '../assets/images/jokers/J13.webp'
import jokerJ14 from '../assets/images/jokers/J14.webp'
import jokerJ15 from '../assets/images/jokers/J15.webp'

export const JOKER_IMAGE: Record<string, string> = {
  J01: jokerJ01, J02: jokerJ02, J03: jokerJ03, J04: jokerJ04,
  J05: jokerJ05, J06: jokerJ06, J07: jokerJ07,
  J08: jokerJ08, J09: jokerJ09, J10: jokerJ10,
  J11: jokerJ11, J12: jokerJ12,
  J13: jokerJ13, J14: jokerJ14, J15: jokerJ15,
}
